export enum MapperConnectionType {
    LinkedServiceType = 'linkedservicetype'
}

export class MapperConnectionReference {
    connectionName: string;
    type: MapperConnectionType;

    constructor(referenceName: string, type: MapperConnectionType) {
        this.connectionName = referenceName;
        this.type = type;
    }

    public static areEqual(a: MapperConnectionReference, b: MapperConnectionReference): boolean {
        if (!a || !b) {
            return false;
        }

        return a.type === b.type && a.connectionName === b.connectionName;
    }

    public getConnectionAlias(): string {
        return this.type + '@' + this.connectionName;
    }

    public isEqualTo(obj: MapperConnectionReference): boolean {
        if (!obj) {
            return false;
        }

        return obj.type === this.type && obj.connectionName === this.connectionName;
    }

    public isValidReference(): boolean {
        return !!this.connectionName && !!this.type;
    }
}
